import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Link } from "react-router-dom";
import "../projects/projects.css";
import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

export const Userinternship = () => {
  const navigate = useNavigate();
  const [internships, setInternships] = useState([]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  useEffect(() => {
    api
      .get(`/internships/get-my-internships/${currentUser?.id}`)
      .then((res) => {
        console.log("internships>", res.data);
        setInternships(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const deleteInternship = (id) => {
    api
      .delete(`/internships/${id}`)
      .then((res) => {
        console.log(res.data);
        window.location.reload();
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className="row">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}
        <div className="col-md-12 col-12">
          {/* <div className="row mt-3">
            <div className="col-6">
              <h3>Internships:</h3>
            </div>
          </div>
          <div className="col-6">
            <Link to="/internship/post" className="btn-link">
              Post an Internship
            </Link>
          </div> */}
          <div className="container">
            {internships.length > 0 ? (
              internships
                .sort(function (a, b) {
                  return new Date(b.updatedAt) - new Date(a.updatedAt);
                })
                .map((inte) => (
                  // <div className="row border-bottom border-dark pb-3">
                  //   <div className="col-lg-6 col-md-6 col-12">
                  //     <h5 className="title">
                  //       <strong>{inte?.companyName}</strong>
                  //     </h5>
                  //   </div>
                  //   <div className="col-lg-6 col-md-6 col-12">
                  //     <p>
                  //       Posted:{" "}
                  //       <strong className="date">
                  //         {new Date(inte?.createdAt).toDateString()}
                  //       </strong>
                  //     </p>
                  //   </div>
                  //   <div className="country">
                  //     <p>
                  //       <strong>Location: </strong>
                  //       {inte?.location}
                  //     </p>
                  //   </div>
                  //   <div className="duration">
                  //     <p>
                  //       <strong>Duration: </strong> {inte?.duration}
                  //     </p>
                  //   </div>
                  //   <div className="Paid/Stipend">
                  //     <p>
                  //       <strong>Paid/Stipend: </strong> {inte?.pay}
                  //     </p>
                  //   </div>

                  //   <div className="desc">
                  //     <p>
                  //       <strong>Description: </strong>
                  //       {inte?.description}
                  //     </p>
                  //   </div>

                  //   <div className="visitlink">
                  //     <h5 className="my-3">Visit Link</h5>
                  //     <a href={inte?.url}>{inte?.url}</a>
                  //   </div>
                  //   <div className=" row  mt-3 mb-3 flex-box justify-left">
                  //     <Link
                  //       to={`/internships/edit/${inte?._id}`}
                  //       className="btn   mr-6 btn"
                  //     >
                  //       Edit Internship
                  //     </Link>
                  //   </div>
                  //   <button
                  //     className="delete__scholarship__btn"
                  //     onClick={(e) => deleteInternship(inte?._id)}
                  //   >
                  //     Delete Internship
                  //   </button>
                  // </div>
                  <Card sx={{ width: "100%" }}>
                    <CardHeader
                      avatar={
                        <Stack direction="column">
                          {currentUser?.profile ? (
                            <Avatar
                              src={currentUser?.profile}
                              alt={currentUser?.name?.at(0)?.toUpperCase()}
                            />
                          ) : (
                            <Avatar
                              sx={{ bgcolor: "colorThree.main" }}
                              aria-label="recipe"
                            >
                              {currentUser?.name?.at(0)?.toUpperCase()}
                            </Avatar>
                          )}
                        </Stack>
                      }
                      // action={
                      //   <IconButton aria-label="settings">
                      //     <MoreVertIcon />
                      //   </IconButton>
                      // }
                      title={currentUser?.name?.toUpperCase()}
                      subheader={new Date(inte?.createdAt).toDateString()}
                    />
                    {/* {hostel?.hostelImage && (
                <CardMedia
                  component="img"
                  height="50"
                  width="50"
                  image={hostel?.hostelImage}
                  alt="Paella dish"
                />
              )} */}

                    <CardContent>
                      <Typography
                        sx={{
                          fontSize: "1.5rem",
                          marginBottom: "10px",
                          fontWeight: "500",
                          textTransform: "capitalize",
                        }}
                        color="fontPrimaryColor.main"
                        className="question__title"
                        // onClick={() => navigate(`/answers/${question._id}`)}
                      >
                        {inte?.companyName}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {inte?.description}
                      </Typography>

                      <Box className="language mt-4 bg-white">
                        <Box className="tags bg-white">
                          {inte?.tags?.map((t) => (
                            <Typography className="tag-span">{t}</Typography>
                          ))}
                        </Box>
                      </Box>
                      {/* <Box className="mt-5">
                  <Typography sx={{ fontSize: "1.2rem", fontWeight: "500" }}>
                    Answers
                  </Typography>
                  <Box className="answer__container">
                    {answers.length > 0 &&
                      answers.map((ans) => (
                        // <Box className="ans">
                        //   <h1>{ans.user.name}</h1>
                        //   <p>{ans.answer}</p>
                        // </Box>
                        <Answer ans={ans} />
                      ))}
                  </Box>
               
                </Box> */}
                      <Box
                        className="country mt-2 mb-1"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Location
                        </Typography>
                        <Typography variant="body2">
                          {inte?.location}{" "}
                        </Typography>
                      </Box>
                      <Box
                        className="duration mb-1"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Duration
                        </Typography>
                        <Typography>{inte?.duration} </Typography>
                      </Box>
                      <Box
                        className="duration mb-1"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Pay/Stipend
                        </Typography>
                        <Typography>{inte?.pay} PKR</Typography>
                      </Box>

                      <Box
                        className="visitlink"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Visit link
                        </Typography>
                        <Typography
                          sx={{
                            color: "blue",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {inte?.url ? inte?.url : "null"}
                        </Typography>
                      </Box>
                    </CardContent>
                    <CardActions>
                      <div className="  mt-3 mb-3 flex-box justify-left ml-auto">
                        <button
                          onClick={() =>
                            navigate(`/edit-internship/${inte?._id}`)
                          }
                          className="asc__submit__form__button mr-2"
                        >
                          Edit Internship
                        </button>
                      </div>
                      <button
                        className=" asc__submit__form__button mr-2"
                        onClick={() => deleteInternship(inte?._id)}
                      >
                        Delete Internship
                      </button>
                    </CardActions>
                  </Card>
                ))
            ) : (
              <h5>No internship posted</h5>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
